import 'css-chunksrc/client/scenes/moveElement/projectsSelection/zones/zone/styles.scss';export default {
  "header": "_header_1heil_1",
  "icon": "_icon_1heil_10",
  "name": "_name_1heil_17",
  "projects": "_projects_1heil_24"
};